import { render } from "./MuayThaiOverlay.vue?vue&type=template&id=6510f6ba&scoped=true"
import script from "./MuayThaiOverlay.vue?vue&type=script&lang=js"
export * from "./MuayThaiOverlay.vue?vue&type=script&lang=js"

import "./MuayThaiOverlay.vue?vue&type=style&index=0&id=6510f6ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6510f6ba"]])

export default __exports__